// ----------------------------------------------------------------------------
// Component: Guarantees Bar
// ----------------------------------------------------------------------------
//
// A repeater of icon and title with the whole bar is clickable and opens a modal.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import '../../snippets/_containers/modal/modal';

import './_guarantee-bar.scss';

import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';

function handleScrollAnimation(section) {
    const icons = section.querySelectorAll('.guarantee__icon');

    icons.forEach((icon, index) => {
        gsap.set(icon, { opacity: 0 });
        let timeline = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: 'top center',
                once: true,
            }
        });
    
        timeline
            .to(icon, { opacity: 0, scale: 1, ease: 'cubic-bezier(0.47, 2.02, 0.31, -0.36)', duration: 0.125, delay: index * 0.25 })
            .to(icon, { opacity: 1, scale: 1.2, ease: 'cubic-bezier(0.47, 2.02, 0.31, -0.36)', duration: 0.125 })
            .to(icon, { opacity: 1, scale: 1, ease: 'cubic-bezier(0.47, 2.02, 0.31, -0.36)', duration: 0.125 });
    });    
}

window.addEventListener('DOMContentLoaded', function() {
    gsap.registerPlugin(ScrollTrigger);
    const sections = document.querySelectorAll('.guarantees');

    sections.forEach((section, index) => {
        section.classList.add(`guarantee-bar--${index}`);
        handleScrollAnimation(section);
    });
});

